<template>
  <div
    class="BaseChip"
    tabindex="0"
    @click="$emit('click')">
    <slot></slot>
    <span
      v-if="showX"
      class="BaseChip_X"
      key="BC-x">
    </span>
  </div>
</template>

<script>
export default {
  name: 'BaseChip',

  props: {
    showX: { type: Boolean, default: true },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

$chip-size: 24px;

.BaseChip {
  display: inline-block;
  height: $chip-size;
  padding: 0 8px;
  margin-right: 4px;
  margin-top: 4px;
  line-height: $chip-size;
  text-transform: capitalize;
  border-radius: $chip-size / 2;
  background-color: lighten($light-blue, 6%);
  cursor: pointer;
  &:hover {
    background-color: $light-blue;
  }
}

.BaseChip_X {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-left: 4px;
  background-image: url('https://web-assets.domo.com/miyagi/images/icon/domo-icon/domo-icon-delete-remove-exit-close-dark.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
